import * as z from "zod";

import { TeamMembershipSchema } from "./team-membership-model";

export type TeamMembershipStatus = "ACTIVE" | "PENDING" | "SUSPENDED" | "LEFT";
export type TeamMembershipRole = "ADMIN" | "USER";

export const TeamSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  visibility: z.string(),
  logo: z.string().nullable().optional(),
  logoType: z.string().nullable().optional(),
  color: z.string().nullable().optional(),
  teamMembershipList: z.array(TeamMembershipSchema),
});

export const TeamWithoutMembershipList = TeamSchema.omit({ teamMembershipList: true });

export type Team = z.infer<typeof TeamSchema>;
export type TeamWithoutMembershipList = z.infer<typeof TeamWithoutMembershipList>;

export const sortTeam = (
  a?: TeamWithoutMembershipList | null | undefined,
  b?: TeamWithoutMembershipList | null | undefined,
  desc: boolean = false,
): 0 | 1 | -1 => {
  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return desc ? 1 : -1;
  }

  if (!b) {
    return desc ? -1 : 1;
  }

  const orderKey = a.name.localeCompare(a.name, undefined, { numeric: true, sensitivity: "accent" });

  if (desc) {
    return orderKey > 0 ? -1 : 1;
  }

  return orderKey > 0 ? 1 : -1;
};
